import * as IconSelector from '../icons';

export const claseTramite = [
    {
        value: 'Solicitud',
        label: 'Solicitud',
        description: 'Solicitud',
        icon: IconSelector.SolicitudesIcon,
        color: 'Blue'
    },
    {
        value: 'Declaracion',
        label: 'Declaración',
        description: 'Declaración',
        icon: IconSelector.DeclaracionesIcon,
        color: 'Green'
    },
    {
        value: 'Auditoria',
        label: 'Auditoría',
        description: 'Auditoría',
        icon: IconSelector.AuditoriasIcon,
        color: 'Orange'
    },
    {
        value: 'Inspeccion',
        label: 'Inspección',
        description: 'Inspección',
        icon: IconSelector.InspeccionesIcon,
        color: 'Red'
    },
    {
        value: 'General',
        label: 'General',
        description: 'General',
        icon: IconSelector.TramitesIcon,
        color: 'Black'
    }
];
